import IApplicationRequest from "./IApplicationRequest";
import IFinancedSubjectBase from "./IFinancedSubjectBase";
import IOriginationContextRequest from "./IOriginationContextRequest";
import ICustomer from "./customer/ICustomer";
import IFinancing from "./IFinancing";

export default class ApplicationRequest implements IApplicationRequest {
    constructor(
        public financedSubject: IFinancedSubjectBase,
        public originationContext: IOriginationContextRequest,
        public financing: IFinancing,
        public customer?: ICustomer
    ) {}
}
